<template>

  <v-flex
    md12
  >
    <div>
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        placeholder="search by brand/material/category/desc"
        clearable
        single-line
        hide-details/>

      <v-dialog
        v-model="dialogDelete"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            Are you sure want to remove this data? <br>
            "{{ deleteItemRecord.brand }} - {{ deleteItemRecord.materialNo }}"
          </v-card-text>
          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="deleteItem(deleteItemRecord)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        id="itemaddselection"
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="DataList"
        :rows-per-page-items="rowsAmount"
        :pagination.sync="pagination"
        :total-items="totalRows"
        item-key="id"
        dense
        select-all
        loading-text="Loading... Please wait"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr
            @click.stop=" (props.expanded = !props.expanded)">
            <td>
              <v-checkbox
                v-model="props.selected"
                hide-details
                primary
                @click.stop="props.selected = !props.selected"
              />
            </td>
            <td>{{ props.item.brand }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.materialNo }}</td>
            <td>{{ props.item.currency }}</td>
            <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
            <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-flex mx-3>
            <v-card>
              <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer/>
          <v-flex mx-3>
            <v-data-table
              id="bundlinglist"
              :items="props.item.items"
              :headers="subHeadersExpand"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.brand }}</td>
                  <td class="">{{ props.item.category }}</td>
                  <td class="">{{ props.item.materialNo }}</td>
                  <td class="">{{ props.item.materialDesc }}</td>
<!--                  <td class="">{{ props.item.currency }}</td>-->
                  <td class="">{{ props.item.qty }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close
        </v-btn>
      </v-snackbar>
    </div>
  </v-flex>

</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'

  export default {
    name: 'ItemBundlingSelect',
    mixins: [displayFormatterMixins],
    data: () => ({
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      expand: true,
      pagination: {},
      paginationSub: {},
      DataList: [],
      selected: [],
      SubDataList: [],
      totalRows: 0,
      totalRowsSub: 0,
      rowsAmount: [5, 10, 20],
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      loadingSub: true,
      search: '',
      searchBy: {
        brand: '',
        category: '',
        materialNo: '',
      },
      searchSub: '',
      headers: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo' },
        { text: 'Curr', value: 'curr' },
        { text: 'Selling Price', value: 'price.sellingPrice' },
        { text: 'Bottom Price', value: 'price.bottomPrice' }
      ],
      subHeaders: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo' },
        { text: 'Curr', value: 'curr' },
        { text: 'Supp Price', value: 'price.suppPrice' },
        { text: 'Selling Price', value: 'price.sellingPrice' },
        { text: 'Bottom Price', value: 'price.bottomPrice' }
      ],
      subHeadersExpand: [
        { text: 'Brand', value: 'brand', sortable: false },
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Material', value: 'materialNo', sortable: false },
        { text: 'Material Desc', value: 'materialDesc', sortable: false },
        { text: 'Qty', value: 'qty', sortable: false },
        { text: 'Selling Price', value: 'price.sellingPrice', sortable: false },
        { text: 'Bottom Price', value: 'price.bottomPrice', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        items: [],
        currency: 'IDR',
        category: '',
        isBundling: true
      },
      suppPriceHint: '(IDR)',
      defaultItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        items: [],
        currency: 'IDR',
        category: '',
        isBundling: true
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {

      selected () {
        console.debug(this.selected)
        this.$store.commit('quo/setSelectedItems', this.selected)
      },
      pagination: {
        async handler () {
          this.getItemsBundling()
        },
        deep: true
      },
      search () {
        this.debouncedGetItemsBundling()
      },
      paginationSub: {
        async handler () {
          this.getItemsNonBundling()
        },
        deep: true
      },
      searchSub () {
        this.debouncedGetItemsNonBundling()
      }
    },
    // called when page is created before dom
    created () {
      this.debouncedGetItemsBundling = _.debounce(this.getItemsBundling, 500)
      this.debouncedGetItemsNonBundling = _.debounce(this.getItemsNonBundling, 500)
    },
    mounted () {
      // this.getItemsBundling()
    },
    methods: {
      setSelectedItemsCheckbox (items) {
        console.debug(items)
        this.selected = items
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      async getItemsBundling () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search

          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/itembundling?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}`)

          this.loading = false
          this.DataList = response.data.content.map(item => {
            let temp = Object.assign({}, item)
            temp.qty = 1
            temp.stockType = 'INDENT'
            return temp
          })
          console.debug('getItems XHR had been modified')
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      async getItemsNonBundling () {
        try {
          this.loadingSub = true
          const { sortBy, descending, page, rowsPerPage } = this.paginationSub
          let q = this.searchSub == null ? '' : this.searchSub
          let qbra = this.searchBy.brand == null ? '' : this.searchBy.brand
          let qcat = this.searchBy.category == null ? '' : this.searchBy.category
          let qmat = this.searchBy.materialNo == null ? '' : this.searchBy.materialNo
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/item?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || ''}
          &dc=${descending || false}&q=${q}&qbra=${qbra}&qcat=${qcat}&qmat=${qmat}`)

          this.loadingSub = false
          this.SubDataList = response.data.content
          this.totalRowsSub = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/item/${rec.id}`
        let method = 'delete'
        let s = {}
        this.DataList.splice(this.DataList.indexOf(rec), 1)
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => this.deleteInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      closed () {
        this.selected = []
      },

      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style scoped>
  #bundlinglist thead tr {
    background-color: #288a2a;
  }

  #bundlinglist thead tr th {
    color: #2196f3;
    font-size: 16px;
  }

  #itemaddselection table.v-datatable thead tr th div.v-input--checkbox  {
    display:none;
  }
</style>
